import React, { useState, useEffect } from 'react';
import { Video, VideoOff, Users, Radio } from 'lucide-react';

const OWNCAST_URL = 'https://live.djsandmc.com';

export function LiveVideo() {
  const [isLive, setIsLive] = useState(false);
  const [viewerCount, setViewerCount] = useState(0);
  const [streamTitle, setStreamTitle] = useState('');
  const [loading, setLoading] = useState(true);
  const [showVideo, setShowVideo] = useState(true);

  useEffect(() => {
    const checkLiveStatus = async () => {
      try {
        const response = await fetch(`${OWNCAST_URL}/api/status`);
        if (response.ok) {
          const data = await response.json();
          setIsLive(data.online);
          setViewerCount(data.viewerCount || 0);
          setStreamTitle(data.streamTitle || 'Live Stream');
        }
      } catch (err) {
        console.log('Could not check live status');
        setIsLive(false);
      }
      setLoading(false);
    };

    checkLiveStatus();
    // Check every 30 seconds
    const interval = setInterval(checkLiveStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div 
        className="glass rounded-2xl p-4 animate-pulse"
        data-testid="live-video-loading"
      >
        <div className="h-4 bg-white/10 rounded w-1/3 mb-3"></div>
        <div className="aspect-video bg-white/10 rounded-xl"></div>
      </div>
    );
  }

  if (!isLive) {
    return (
      <div 
        className="glass rounded-2xl p-4"
        data-testid="live-video-offline"
      >
        <div className="flex items-center gap-2 mb-3">
          <VideoOff className="w-5 h-5" style={{ color: 'var(--text-muted)' }} />
          <h3 
            className="text-lg font-bold"
            style={{ fontFamily: 'Teko, sans-serif', color: 'var(--text-main)' }}
          >
            Live Video
          </h3>
        </div>
        <div 
          className="aspect-video rounded-xl flex flex-col items-center justify-center"
          style={{ backgroundColor: 'var(--surface-highlight)' }}
        >
          <Radio className="w-12 h-12 mb-2" style={{ color: 'var(--text-muted)' }} />
          <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
            DJ is not streaming video
          </p>
          <p className="text-xs mt-1" style={{ color: 'var(--text-muted)' }}>
            Enjoying audio only
          </p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="glass rounded-2xl p-4"
      data-testid="live-video-panel"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="relative">
            <Video className="w-5 h-5" style={{ color: '#EF4444' }} />
            <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
          </div>
          <h3 
            className="text-lg font-bold"
            style={{ fontFamily: 'Teko, sans-serif', color: 'var(--text-main)' }}
          >
            LIVE
          </h3>
        </div>
        
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1 text-xs" style={{ color: 'var(--text-muted)' }}>
            <Users className="w-3 h-3" />
            <span>{viewerCount} watching</span>
          </div>
          <button
            onClick={() => setShowVideo(!showVideo)}
            className="text-xs px-2 py-1 rounded"
            style={{ 
              backgroundColor: 'var(--surface-highlight)',
              color: 'var(--text-muted)'
            }}
          >
            {showVideo ? 'Hide' : 'Show'}
          </button>
        </div>
      </div>

      {streamTitle && (
        <p className="text-xs mb-2 truncate" style={{ color: 'var(--text-muted)' }}>
          {streamTitle}
        </p>
      )}

      {showVideo && (
        <div className="aspect-video rounded-xl overflow-hidden bg-black">
          <iframe
            src={`${OWNCAST_URL}/embed/video`}
            title="Live Stream"
            className="w-full h-full"
            frameBorder="0"
            allowFullScreen
            allow="autoplay; fullscreen"
            referrerPolicy="origin"
          />
        </div>
      )}
    </div>
  );
}
